import { assert, getFile, type Folder } from "./state"

export const FIELD_LOOKS = ["title", "header", "default", "html", "hidden"] as const
export type FieldLook = typeof FIELD_LOOKS[number]
export type ViewConfig = Record<string, FieldLook>

const defaults: ViewConfig = {id: "hidden", title: "title", depiction: "header"}
const looks = new Set<string>(FIELD_LOOKS)
const defaultConfig = (): ViewConfig => Object.assign(Object.create(null), defaults) as ViewConfig

export function fieldsWithLook(value: Record<string, unknown>, config: ViewConfig, look: FieldLook): [string, unknown][] {
  return Object.entries(value).filter(([field]) => (config[field] ?? "default") === look)
}

export function readViewConfig(state: Folder): ViewConfig {
  const source = getFile(state, ["config.json"])
  if (source === undefined) return defaultConfig()

  let value: unknown
  try { value = JSON.parse(source) }
  catch { throw new Error("config.json must contain valid JSON") }
  assert(typeof value === "object" && value !== null && !Array.isArray(value), "config.json must be an object")

  const config = defaultConfig()
  for (const [field, look] of Object.entries(value)) {
    assert(looks.has(String(look)), `Unknown look for ${field}: ${String(look)}`)
    config[field] = look as FieldLook
  }
  return config
}
